import { RootState } from '../store';

export const getAccounts = (state: RootState) => state.accounts.WALLESTER.accounts;

export const getAccountsArray = (state: RootState) => Object.values(getAccounts(state));

export const getCurrentAccount = (state: RootState) =>
  state.accounts.WALLESTER.currentAccount;

export const getCurrentAccountObject = (state: RootState) => {
  const currentAccount = getCurrentAccount(state);

  return state.accounts.WALLESTER.accounts[currentAccount!]; //TODO: Обработать currentAccount = null
};

export const getAccountMeta = (state: RootState) => state.accounts.WALLESTER.meta;

export const getAccountAddressString = (state: RootState) => {
  const meta = getAccountMeta(state);
  const addressString =
    meta.person.address +
    ', ' +
    meta.person.city +
    ', ' +
    meta.person.country +
    ', ' +
    meta.person.postal_code;
  return addressString;
};

export const getTotalBalance = (state: RootState) => {
  const accountsArray = getAccountsArray(state);

  return accountsArray
    ? accountsArray.reduce((sum, account) => sum + account.available, 0)
    : 0;
};

export const getAccountBalance = (state: RootState) => {
  const currentAccountObject = getCurrentAccountObject(state);
  return currentAccountObject?.available;
};

export const getAccountTitle = (state: RootState) => {
  const currentAccountObject = getCurrentAccountObject(state);
  return currentAccountObject?.title;
};
export const getAccountIsSoftBlocked = (state: RootState) => {
  const currentAccountObject = getCurrentAccountObject(state);
  return currentAccountObject?.isSoftBlocked;
};

export const getAccountIBAN = (state: RootState) => {
  const currentAccountObject = getCurrentAccountObject(state);
  return currentAccountObject?.iban;
};

export const getIsSoftBlocked = (state: RootState) =>
  state.accounts.WALLESTER.isSoftBlocked;
